import { ref } from 'vue'

import { useStoreMediaDevices } from '@/entities/media-devices'

export const useLocalWebcamVideo = () => {
  const webcamElement = ref<HTMLVideoElement>()
  const { closeStream, openWebcam } = useStoreMediaDevices()
  const currentStream = ref()


  const startLocalStream = async () => {
    closeWebcam()
    return openWebcam().then((mediaStream: MediaStream) => {
      currentStream.value = mediaStream
      if (webcamElement.value) {
        webcamElement.value.srcObject = mediaStream
      }
      return mediaStream
    })
  }

  const closeWebcam = () => {
    if (webcamElement.value) {
      webcamElement.value.srcObject = null
    }

    if (currentStream.value) {
      closeStream(currentStream.value)
      currentStream.value = null
    }
  }

  return {
    webcamElement,
    startLocalStream,
    closeWebcam,
  }
}
